import React from 'react';
import { NavLink } from 'react-router-dom';
import classes from './NavigationItem.css';

import './NavigationItem.css';

const navigationItem = ( props ) => {
    let navClassArray = [classes.NavigationItem];
    navClassArray.push(classes.Uppercase);
    return (
        <li className={navClassArray.join(' ')}>
            <NavLink
                to={props.link}
                exact
                activeClassName={classes.active}
            >
                {props.children}
            </NavLink>
        </li>
    )
};

export default navigationItem;


// WEBPACK FOOTER //
// ./src/Components/Navigation/NavigationItems/NavigationItem/NavigationItem.js